
import { NoseurObject } from "@rivtn/noseur";
import { Actor, SanitizedResponse } from "../BaseService";
import { PloutousBaseService } from "./PloutousBaseService";

export interface ICurrency {
    name: string;
    code: string;
    sign: string;
    status: string;
    created_by: Actor;
    updated_by: Actor;
    created_at: string;
    updated_at: string;
    external_id: string;
}

export class CurrencyService extends PloutousBaseService {

    protected static instance: CurrencyService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!CurrencyService.instance) CurrencyService.instance = new CurrencyService();
        return CurrencyService.instance;
    }

    queryCurrencies(params: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<any> {
        return this.report(this.transport.get("/api/v1/currency", { query: this.normalizeParams(params) }));
    }

    getCurrencyByCode(code: string): Promise<SanitizedResponse<ICurrency>> {
        return this.report(this.transport.get(`/api/v1/currency/code/${code}`, { cache: true, key: `CURRENCY_${code}` }));
    }

    createCurrency(payload: any): Promise<SanitizedResponse<ICurrency>> {
        return this.report(this.transport.post(`/api/v1/currency`, payload));
    }

    updateCurrency(payload: Partial<ICurrency>): Promise<SanitizedResponse<ICurrency>> {
        const id = payload.external_id; delete payload.external_id;
        return this.report(this.transport.patch(`/api/v1/currency/${id}`, payload));
    }

    deleteCurrency(id: string): Promise<SanitizedResponse<ICurrency>> {
        return this.report(this.transport.delete(`/api/v1/currency/${id}`));
    }

}
